export default __webpack_public_path__ + "static/media/sicon-user_guide.feb746e0.svg";